import React from "react";
import Gallery from "@/components/Gallery";

export default function GalleryPage() {
  return <Gallery />;
}
